import {
    Component,
    forwardRef,
    Input,
    OnDestroy,
    OnInit
  } from '@angular/core';
  import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
  import { ACLService } from '@delon/acl';
  import { _HttpClient } from '@delon/theme';

import { PurchaseDocTransferService } from '../../_providers/purchase-doc-transfer.service';
    
  @Component({
    selector: 'app-purchase-doc-transfer',
    templateUrl: './purchase-doc-transfer.component.html',
    styles: [],
    styleUrls: ['./purchase-doc-transfer.component.less'],
    standalone: false,
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PurchaseDocTransferComponent),
        multi: true
      }
    ]
  })
  export class PurchaseDocTransferComponent
    implements OnInit, OnDestroy, ControlValueAccessor
  {
    constructor(
      private acl: ACLService,
      public srv: PurchaseDocTransferService
    ) {}

    @Input() docType: string = '';

    @Input() supplierId: string = '';

    @Input() transferredDocIds: string[] = [];

    @Input() transferToDocCode: string = '';

    filterDate = [];
    docFrom = '';
    docTo = '';

    disabled = false;

    columns: any[] = [
      {
        title: 'Date',
        width: '120px',
        align: 'center'
      },
      {
        title: 'Doc #',
        width: '120px',
        align: 'center'
      },
      {
        title: 'Reference No',
        width: '150px'
      },
      {
        title: 'Supplier Name',
        index: 'supplierName',
        width: '200px'
      },
      {
        title: 'Net Amount',
        align: 'right',
        width: '120px'
      }
    ];

    private transferItems: any[] = [];
    onChange: any = () => {};
    onTouched: any = () => {};
    writeValue(value: any[]): void {
      if (value && value.length) {
        this.transferItems = [...value];
        this.srv.outstandingDocs = [...value];
      } else {
        this.transferItems = [];
        this.srv.outstandingDocs = [];
      }
    }

    registerOnChange(fn: any): void {
      this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
      this.disabled = isDisabled;
      if (this.disabled) {
        if (this.transferItems)
          this.srv.outstandingDocs = [...this.transferItems];
        else this.srv.outstandingDocs = [];
      }
    }

    ngOnInit(): void {
      this.columns = this.columns.filter(
        col => !col.acl || this.acl.canAbility(col.acl)
      );
      this.reloadData();
    }

    ngOnDestroy(): void {
      this.transferItems = [];
      this.srv.outstandingDocs = [];
    }

    reloadData() {
      if (this.disabled) return;
      this.srv.reload(
        this.docType,
        this.supplierId,
        this.transferredDocIds,
        this.filterDate[0],
        this.filterDate[1],
        this.docFrom,
        this.docTo,
        this.transferToDocCode
      );
    }

    toggleTransfer(item: any) {
      if (this.disabled) return;
      item.isTransfer = !item.isTransfer;
      // two-way binding
      // const selectedDocIds = this.srv.outstandingDocs.filter(x=>x.isTransfer).map(x=>x.docId);
      // this.selectedDocIds = [...selectedDocIds];
      // this.selectedDocIdsChange.emit(this.selectedDocIds);
    }

    onDateChange(result: Date[]): void {
      this.reloadData();
    }

    onDocChange(): void {
      this.reloadData();
    }
  }
  